/**
 * Application Constants
 * Centralized configuration for the application
 */

export const APP_CONFIG = {
  name: 'Relentless Performance Training',
  description: 'Official website of Relentless Performance Training in San Antonio, Texas',
  author: 'Adrian Callies',
  location: {
    address: '16215 University Oak',
    city: 'San Antonio',
    state: 'TX',
    zip: '78249',
  },
} as const

export const SOCIAL_LINKS = {
  facebook: 'https://www.facebook.com/keith.callies',
  instagram: 'https://www.instagram.com/relentless.e.d.u/',
  instagramAlt: 'https://www.instagram.com/relentless.p.t/?hl=en',
} as const

export const EXTERNAL_LINKS = {
  onlineStore: 'https://relentless-performance-training.square.site/',
  mobileApp: 'https://app.buildfire.com/promo/Relentless%20Movement',
  calendlyYoga: 'https://calendly.com/relentlesspt/relentless-power-yoga-class',
  calendlyStrength: 'https://calendly.com/relentlesspt/relentless-strength-mobility',
  dropInBlog: 'https://io.dropinblog.com/embedjs/4df4167e-d67c-410a-853d-07257dd20cd7.js',
} as const

export const ANALYTICS = {
  googleAnalyticsId: 'UA-264521727-1',
} as const

export const ROUTES = {
  home: '/',
  about: '/about',
  classes: '/classes',
  gallery: '/gallery',
  testimonials: '/testimonials',
  trainers: '/trainers',
  contact: '/contact',
  formSuccess: '/form-success',
} as const

export const IMAGES = {
  logo: '/images/relentless images/relentless-logo.jpg',
  favicon: '/images/relentless images/relentless-logo.ico',
  profile: '/images/Profile.jpg',
  solidBlack: '/images/solid-black-img.jpg',
  coverPage1: '/images/Cover_page1.jpg',
  coverPage2: '/images/Cover_Page2.jpg',
  coverPage3: '/images/Cover_Page3.jpg',
} as const


